import { Notify as Notify_ } from 'quasar'

export class Notify {
  static create({
    position = 'top-right',
    type,
    message,
    html,
    group,
    actions = [{ icon: 'close', round: true }],
  }) {
    return Notify_.create({
      position,
      type,
      message,
      html,
      group,
      actions,
    })
  }
}
